import { apiClient } from '@/lib/api-client';

export interface ImportValidationResult {
  success: boolean;
  message: string;
  data?: {
    preview?: {
      title: string;
      sections_count: number;
      created_at?: string;
      cover_image?: string;
    };
    stats?: {
      sections: number;
      lessons: number;
      items: number;
      images: number;
      videos: number;
      scorm: number;
    };
  };
}

export interface ImportResult {
  success: boolean;
  message: string;
  data?: {
    _id?: string;
    id?: string;
    book?: any;
    stats?: any;
    [key: string]: any;
  };
}

export const importApi = {
  /**
   * Validate Dlow JSON file before import
   */
  validateDlowJson: async (file: File): Promise<ImportValidationResult> => {
    const formData = new FormData();
    formData.append('file', file);

    const response = await apiClient.post<ImportValidationResult>(
      'book/import/dlow-json/validate',
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    );

    return response.data;
  },

  /**
   * Import book from Dlow JSON format
   */
  importFromDlowJson: async (file: File): Promise<ImportResult> => {
    const formData = new FormData();
    formData.append('file', file);

    const response = await apiClient.post<ImportResult>(
      'book/import/dlow-json',
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    );

    return response.data;
  },

  /**
   * Import content into existing book from standard JSON
   */
  importContentJson: async (bookId: string, jsonData: any, mode: 'append' | 'replace'): Promise<ImportResult> => {
    const response = await apiClient.post<ImportResult>(
      `book/${bookId}/import/content-json`,
      {
        json_data: jsonData,
        mode: mode
      }
    );

    return response.data;
  },

  /**
   * Import content into existing book from Dlow JSON
   */
  importContentDlowJson: async (bookId: string, file: File, mode: 'append' | 'replace'): Promise<ImportResult> => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('mode', mode);

    const response = await apiClient.post<ImportResult>(
      `book/${bookId}/import/content-dlow-json`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    );

    return response.data;
  },
};

